
(function($) {
    
    $(document).ready(function(){

        var photoGallerySlideshow = $('.photo-slider').slick({
            lazyLoad: 'ondemand',
            fade: true,
            slidesToShow:       1,
            slidesToScroll:     1,
            arrows:             true,
            dots:               false,
            infinite:           true,
            adaptiveHeight:     false,
            centerMode:         true,
        });

        $( ".slick-slide" ).each(function( index ) { 
            $( this ).css('margin-top',
                ($('.slick-slider').height()-$(this).height())/2+'px' );
        });

        $('.slideshow-thumbnail-item').on('click', function () {
            var imageIndex = $(this).data('image-index');
            $('#photoModal').modal('show');

            setTimeout(function () {
                photoGallerySlideshow.slick('slickGoTo', imageIndex);
            }, 500);
        });

        $('#photoModal').on('shown.bs.modal', function () {
            $('#thumbsModal').modal('hide');
        });

        /*
        $('.photo-slider').slick({
            slidesToShow:       1,
            slidesToScroll:     1,
            arrows:             true,
            dots:               false,
            infinite:           true,
            adaptiveHeight:     false
        });
        */



    });
    
/*
    $(window).on('load resize orientationchange', function () {
        $('.photo-slider').each(function () {
            var $carousel = $(this);
            if (!$carousel.hasClass('slick-initialized')) {
                $carousel.slick({
                    arrows: true,
                    accessibility: false,
                    dots: true,
                    respondTo: 'window',
                    pauseOnFocus: true,
                    pauseOnHover: true,

                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    
                })

                .on('setPosition', function (event, slick) {
                    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
                });
            }
        });
    });
*/

    // Sets width of slider nested inside of tabs
    $('#photoModal').on('shown.bs.modal', function (e) {
        $('.slick-slider').slick('setPosition');
    });


}(jQuery));